import { render } from "./ScrollTopBtn.vue?vue&type=template&id=39990b28&scoped=true"
import script from "./ScrollTopBtn.vue?vue&type=script&lang=js"
export * from "./ScrollTopBtn.vue?vue&type=script&lang=js"

import "./ScrollTopBtn.vue?vue&type=style&index=0&id=39990b28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39990b28"]])

export default __exports__